import React from 'react';
import { Toaster, toast } from 'react-hot-toast';

export const SuccessErrorToaster = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      }}
    />
  );
};

export const showSuccessToast = (message, duration = 3000) => {
  toast.success(message, { duration });
};

export const showErrorToast = (message, duration = 3000) => {
  toast.error(message, { duration });
};